/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_BothInputs */

const en_method_both = /** @type {(inputs: Method_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`both`)
};

const he_method_both = /** @type {(inputs: Method_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שניהם`)
};

/**
* | output |
* | --- |
* | "both" |
*
* @param {Method_BothInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const method_both = /** @type {((inputs?: Method_BothInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_BothInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_method_both(inputs)
	return he_method_both(inputs)
});